<template>
  <div
    v-if="!isLoading && nextActions.length === 0"
    class="p-4 w-full flex flex-col gap-y-4 bg-white text-center"
  >
    {{ $t('NoRecordFound') }}
  </div>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue'
import axiosInstance from '@/services'

const paginatorConfig = reactive({
  totalItemCount: 0,
  itemsPerPage: 5,
  currentPage: 1,
  pageCount: 0
})

const nextActions = ref([])
const isLoading = ref(true)

onMounted(async () => {
  await fetchNextActions()
})

async function fetchNextActions() {
  isLoading.value = true
  const body = {
    currentPage: paginatorConfig.currentPage,
    pageSize: paginatorConfig.itemsPerPage
  }

  const response = await axiosInstance.post('/api/service/whatIsNext/all', body)
  nextActions.value = []

  isLoading.value = false
}
</script>

<style lang="scss" scoped></style>
